import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("isLoggedIn") === "true");
  const [userRole, setUserRole] = useState(localStorage.getItem("userRole") || "");

  useEffect(() => {
    const storedLoginTime = parseInt(localStorage.getItem("loginTime"), 10); // Sayıya çevir
    const currentTime = Date.now();
    const oneDay = 23 * 60 * 60 * 1000; // 23 saat

    if (storedLoginTime && currentTime - storedLoginTime > oneDay) {
      logout(); // Süre dolduysa çıkış
    }
  }, []);

  const login = (role) => {
    const loginTimestamp = Date.now();
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("userRole", role);
    localStorage.setItem("loginTime", loginTimestamp.toString());

    setIsLoggedIn(true);
    setUserRole(role);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUserRole("");

    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userRole");
    localStorage.removeItem("loginTime");
    localStorage.removeItem("token");
    localStorage.setItem("cookieAccepted", "false");

    // Buraya Redux veya context temizliği gerekiyorsa eklenebilir
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userRole, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
